var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFigmaicon = function SvgFigmaicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.866 5.6a2.667 2.667 0 0 0-1.6-4.8H5.468a2.666 2.666 0 0 0-1.6 4.8 2.666 2.666 0 0 0 .092 4.332 2.933 2.933 0 1 0 4.708 2.333v-2.4a2.666 2.666 0 1 0 3.2-4.266Zm0-2.134a1.6 1.6 0 0 1-1.6 1.6h-1.6v-3.2h1.6a1.6 1.6 0 0 1 1.6 1.6Zm-7.999 0a1.6 1.6 0 0 1 1.6-1.6H7.6v3.2H5.467a1.6 1.6 0 0 1-1.6-1.6Zm1.6 5.866a1.6 1.6 0 1 1 0-3.2H7.6v3.2H5.467ZM7.6 12.265A1.867 1.867 0 1 1 5.734 10.4H7.6v1.866Zm2.667-2.933a1.6 1.6 0 1 1 0-3.2 1.6 1.6 0 0 1 0 3.2Z"
  })));
};
export default SvgFigmaicon;